module.exports = __webpack_public_path__ + "static/media/baner_my_favourite_training.2653a37c.jpg";